import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "posGetReadyModal" */ './POSGetReadyModal')),
);

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'POSGetReadyModal');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as POSGetReadyModal };
